/**
 * Body editor for the negate step: create-vs-in-place mode toggle, the new
 * variable name (create mode only), and the source-field slot.
 */
import React from "react"
import { Radio } from "antd"
import type { RadioChangeEvent } from "antd"
import { QueryBuilderStore } from "stores/queryBuilderStore"
import { NegateStep } from "types/queryBuilder.types"
import SingleFieldSlot from "../SingleFieldSlot.component"
import { StepBodyProps } from "./stepBodyProps"

export interface NegateStepBodyProps extends StepBodyProps<NegateStep> {
  renameStep: QueryBuilderStore["renameTransformStep"]
  setMode: QueryBuilderStore["setStepMode"]
  setSingle: QueryBuilderStore["setStepSingleSource"]
}

const NegateStepBody: React.FC<NegateStepBodyProps> = ({
  step,
  renameStep,
  setMode,
  setSingle,
}) => (
  <>
    <div className="qc-step__field-row">
      <span className="qc-step__field-label">Mode:</span>
      <Radio.Group
        value={step.mode}
        onChange={(e: RadioChangeEvent) => setMode(step.id, e.target.value)}
        size="small"
      >
        <Radio.Button value="create">Create new (inverted copy)</Radio.Button>
        <Radio.Button value="in_place">Invert in place</Radio.Button>
      </Radio.Group>
    </div>
    {step.mode === "create" && (
      <input
        className="qc-recodes__name qc-mono"
        type="text"
        value={step.name}
        onChange={(e) => renameStep(step.id, e.target.value)}
        placeholder="New variable name (use // for nesting)"
        aria-label="Variable name"
      />
    )}
    <div className="qc-step__field-row">
      <span className="qc-step__field-label">
        {step.mode === "in_place" ? "Field to flip:" : "Source field:"}
      </span>
      <SingleFieldSlot
        value={step.source}
        onChange={(v) => setSingle(step.id, v)}
        placeholder={
          step.mode === "in_place"
            ? "Drag the field to invert in place"
            : "Drag the field to negate"
        }
      />
    </div>
  </>
)

export default NegateStepBody
